// extracted by mini-css-extract-plugin
export default {"centered-container":"acctManagement_centered-container__b5LNW"};